import { IAttachment } from './IAttachment';
import { IFormData } from './../../shared/utility';

export enum ESuekEducationStatus {
  OPEN = "OPEN",
  DONE = "DONE"
}

export enum EParticipantDataCollection {
  QR = "QR",
  SUBSCRIBER_DELIVERS = "SUBSCRIBER_DELIVERS",
  PAPER = "PAPER",
}

export enum ESUEKEducationDropzoneType {
  PARTICIPANT_LIST = "PARTICIPANT_LIST",
  TRAINING_MATERIAL = "TRAINING_MATERIAL",
}


export enum ESuekTopic {
  CLEAN_SPORT_PRINCIPLES = "CLEAN_SPORT_PRINCIPLES",
  RIGHTS_RESPONSIBILITIES = "RIGHTS_RESPONSIBILITIES",
  ANTI_DOPING_CODE_AND_ACTORS = "ANTI_DOPING_CODE_AND_ACTORS",
  STRICT_LIABILITY = "STRICT_LIABILITY",
  UNINTENTIONAL_DOPING = "UNINTENTIONAL_DOPING",
  DOPING_EFFECTS = "DOPING_EFFECTS",
  DOPING_VIOLATIONS = "DOPING_VIOLATIONS",
  PROHIBITED_SUBSTANCES = "PROHIBITED_SUBSTANCES",
  SUPPLEMENT_RISKS = "SUPPLEMENT_RISKS",
  TUE = "TUE",
  DOPING_TESTING = "DOPING_TESTING",
  TEST_PROTOCOL_URINE = "TEST_PROTOCOL_URINE",
  TEST_PROTOCOL_BLOOD = "TEST_PROTOCOL_BLOOD",
  TESTING_POOL_ADAMS = "TESTING_POOL_ADAMS",
  SPEAK_UP = "SPEAK_UP",
}

export const SUEK_TOPIC_OPTIONS = [
  { value: ESuekTopic.CLEAN_SPORT_PRINCIPLES, text: "Puhtaaseen urheiluun liittyvät periaatteet ja arvot" },
  { value: ESuekTopic.RIGHTS_RESPONSIBILITIES, text: "Urheilutoimijoiden oikeudet ja vastuut" },
  { value: ESuekTopic.ANTI_DOPING_CODE_AND_ACTORS, text: "Antidopingsäännöstö ja -toimijat" },
  { value: ESuekTopic.STRICT_LIABILITY, text: "Ankaran vastuun periaate" },
  { value: ESuekTopic.UNINTENTIONAL_DOPING, text: "Tahaton doping" },
  { value: ESuekTopic.DOPING_EFFECTS, text: "Dopingin vaikutukset: fyysiset, sosiaaliset, taloudelliset" },
  { value: ESuekTopic.DOPING_VIOLATIONS, text: "Dopingrikkomukset" },
  { value: ESuekTopic.PROHIBITED_SUBSTANCES, text: "Kielletyt aineet ja menetelmät urheilussa" },
  { value: ESuekTopic.SUPPLEMENT_RISKS, text: "Ravintolisien käyttöön liittyvät riskit" },
  { value: ESuekTopic.TUE, text: "Erivapaus urheilijan lääkityksessä" },
  { value: ESuekTopic.DOPING_TESTING, text: "Dopingtestaus" },
  { value: ESuekTopic.TEST_PROTOCOL_URINE, text: "Testiprotokolla: virtsatesti" },
  { value: ESuekTopic.TEST_PROTOCOL_BLOOD, text: "Testiprotokolla: veritesti" },
  { value: ESuekTopic.TESTING_POOL_ADAMS, text: "Testauspooli, ADAMS-järjestelmä ja olinpaikkatiedot" },
  { value: ESuekTopic.SPEAK_UP, text: "Dopingia koskevien huolenaiheiden nostaminen esille" },
];


export interface ITargetGroup {
  id: string;
  name: string;
  amount: number;
}

export interface ISuekEducation extends IFormData {
  id: number;
  status: ESuekEducationStatus;
  name: string;
  place: string;
  startDate: string;
  endDate: string;
  theme: string[];
  sport: string;
  targetGroups: ITargetGroup[];
  contactPerson: string;
  additionalInfo: string;
  duration: string;
  participantsEstimate: number;
  participantsReality: number;
  subscriber: string;
  lecturerComments: string;
  participantsFeedback: string;
  subscriberFeedback: string;
  participantDataCollection: EParticipantDataCollection;
  topics: ESuekTopic[];
  implementationAndMaterials: string;
  attachments: IAttachment[];
}